
export interface NavigationState {
  isLastQuestion: boolean
  isFirstQuestion: boolean
  questionIndex: number
  questionCount: number 
}

export interface NavigationOptions {
  updateLastIndex: boolean
}

export interface InputNavigation {
  questionIndex: number
  lastIndex: number
}

export class QuizNavigationState implements NavigationState {
  private currentIndex: number
  private lastIndex: number

  constructor(readonly questionCount: number) {
    this.currentIndex = -1
    this.lastIndex = -1
  }

  load(navigation: InputNavigation) {
    this.currentIndex = navigation.questionIndex
    this.lastIndex = navigation.lastIndex
  }

  goToNextQuestion(options: NavigationOptions) {
    return this.updateCurrentQuestion(this.nextQuestionIndex, options)
  }

  get nextQuestionIndex() {
    return this.currentIndex + 1
  }

  goToPreviousQuestion(options: NavigationOptions) {
    return this.updateCurrentQuestion(this.previousQuestionIndex, options)
  }

  get previousQuestionIndex() {
    return this.currentIndex - 1
  }

  isQuestionReachable(questionIndex: number) {
    return this.isValidIndex(questionIndex)
  }

  updateCurrentQuestion(questionIndex: number, options: NavigationOptions) {
    if (this.isValidIndex(questionIndex)) {
      this.currentIndex = questionIndex
      if (options.updateLastIndex && questionIndex > this.lastIndex) {
        this.lastIndex = questionIndex
      }
      return true
    }

    return false
  }

  exportState() {
    return {
      questionIndex: this.questionIndex,
      lastIndex: this.lastVisitedIndex
    }
  }

  public get questionIndex() {
    return this.currentIndex
  }

  public get isAtQuestion() {
    return this.isValidIndex(this.currentIndex)
  }

  get lastVisitedIndex() {
    return this.lastIndex
  }

  get isFirstQuestion() {
    return this.currentIndex === 0
  }

  get isLastQuestion() {
    return this.currentIndex === this.questionCount - 1
  }

  private isValidIndex(questionIndex: number) {
    return questionIndex >= 0 && questionIndex < this.questionCount
  }
}
